import { Tooltip } from '@blissbook/ui/lib'
import {
  type DocumentPhase,
  type DocumentPhaseDocument,
  getDocumentPhase,
} from './DocumentPhase'

type DocumentStatusViewProps = {
  compact?: boolean
}

export function DocumentPhaseDocumentView({
  document,
  ...props
}: DocumentStatusViewProps & {
  document: DocumentPhaseDocument
}) {
  const { activeReviewRound } = document
  const contentModified = activeReviewRound?.initialHtmlHash
    ? activeReviewRound.initialHtmlHash !== document.draftVersion.htmlHash
    : false
  const phase = getDocumentPhase(document)
  return (
    <DocumentPhaseView
      {...props}
      contentModified={contentModified}
      phase={phase}
    />
  )
}

export function DocumentPhaseView({
  compact,
  contentModified,
  phase,
}: DocumentStatusViewProps & {
  contentModified?: boolean
  phase: DocumentPhase
}) {
  return (
    <div className='tw-flex tw-items-center tw-gap-1'>
      <Tooltip
        content={
          contentModified
            ? `${phase.label} (content modified since Review began)`
            : phase.label
        }
        disabled={!compact}
        placement='right'
      >
        <div className={`tw-relative ${contentModified ? 'tw-mx-1' : ''}`}>
          {contentModified && (
            <div
              className='tw-absolute tw-rounded-full tw-border-2 tw-border-gray-500 tw-border-dashed'
              style={{ inset: -4 }}
            />
          )}
          <div
            className='tw-flex tw-items-center tw-justify-center'
            style={{ width: '1em', height: '1em' }}
          >
            {phase.icon}
          </div>
        </div>
      </Tooltip>

      {!compact && (
        <span className='tw-flex-1 tw-min-w-0 ellipsis'>{phase.label}</span>
      )}
    </div>
  )
}
